var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfieIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 105,
    viewBox: "0 0 118 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.438 13.125H86.1023L78.0031 0.973437C77.8037 0.674548 77.5337 0.429382 77.2171 0.259604C76.9004 0.0898264 76.5468 0.000665251 76.1875 0H41.1875C40.8282 0.000665251 40.4746 0.0898264 40.1579 0.259604C39.8413 0.429382 39.5713 0.674548 39.3719 0.973437L31.2617 13.125H14.9375C12.0367 13.125 9.2547 14.2773 7.20352 16.3285C5.15234 18.3797 4 21.1617 4 24.0625V85.3125C4 88.2133 5.15234 90.9953 7.20352 93.0465C9.2547 95.0977 12.0367 96.25 14.9375 96.25H102.438C105.338 96.25 108.12 95.0977 110.171 93.0465C112.223 90.9953 113.375 88.2133 113.375 85.3125V24.0625C113.375 21.1617 112.223 18.3797 110.171 16.3285C108.12 14.2773 105.338 13.125 102.438 13.125ZM109 85.3125C109 87.053 108.309 88.7222 107.078 89.9529C105.847 91.1836 104.178 91.875 102.438 91.875H14.9375C13.197 91.875 11.5278 91.1836 10.2971 89.9529C9.0664 88.7222 8.375 87.053 8.375 85.3125V24.0625C8.375 22.322 9.0664 20.6528 10.2971 19.4221C11.5278 18.1914 13.197 17.5 14.9375 17.5H32.4375C32.7977 17.5002 33.1524 17.4115 33.4701 17.2417C33.7878 17.0719 34.0587 16.8262 34.2586 16.5266L42.3523 4.375H75.0117L83.1164 16.5266C83.3163 16.8262 83.5872 17.0719 83.9049 17.2417C84.2226 17.4115 84.5773 17.5002 84.9375 17.5H102.438C104.178 17.5 105.847 18.1914 107.078 19.4221C108.309 20.6528 109 22.322 109 24.0625V85.3125ZM58.6875 30.625C54.361 30.625 50.1317 31.9079 46.5344 34.3116C42.9371 36.7153 40.1333 40.1317 38.4776 44.1288C36.822 48.1259 36.3888 52.5243 37.2328 56.7676C38.0769 61.0109 40.1603 64.9087 43.2195 67.968C46.2788 71.0272 50.1766 73.1106 54.4199 73.9547C58.6632 74.7987 63.0616 74.3655 67.0587 72.7099C71.0558 71.0542 74.4722 68.2504 76.8759 64.6531C79.2796 61.0558 80.5625 56.8265 80.5625 52.5C80.5625 46.6984 78.2578 41.1344 74.1555 37.032C70.0531 32.9297 64.4891 30.625 58.6875 30.625ZM58.6875 70C55.2263 70 51.8429 68.9736 48.965 67.0507C46.0872 65.1278 43.8441 62.3947 42.5196 59.197C41.1951 55.9993 40.8485 52.4806 41.5238 49.0859C42.199 45.6913 43.8657 42.573 46.3131 40.1256C48.7605 37.6782 51.8788 36.0115 55.2734 35.3363C58.6681 34.661 62.1868 35.0076 65.3845 36.3321C68.5822 37.6566 71.3153 39.8997 73.2382 42.7775C75.1611 45.6554 76.1875 49.0388 76.1875 52.5C76.1875 57.1413 74.3438 61.5925 71.0619 64.8744C67.78 68.1563 63.3288 70 58.6875 70Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_20",
    x: 0,
    y: 0,
    width: 117.375,
    height: 104.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_20",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfieIcon);
export default __webpack_public_path__ + "static/media/selfie-icon.1df507895daaca978c6aa94c51ce5af7.svg";
export { ForwardRef as ReactComponent };